/**
 * Redux thunk action creators.
 * These may call facades. Prefer createAsyncThunk.
 */

import { createAsyncThunk, SerializedError } from '@reduxjs/toolkit';
import { ApiFacade } from '../facades/apiFacade';
import { UserResponse } from '../../@types/user';
import { API_BASE_URL } from '../../apiConfig';
import type { ThunkAPI } from '../stores/store';

export type FetchCurrentUserArgs = {
    accessToken: string;
};

export const fetchCurrentUser = createAsyncThunk<UserResponse, FetchCurrentUserArgs, ThunkAPI>(
    'user/fetchCurrentUser',
    async (args: FetchCurrentUserArgs, thunkApi) => {
        try {
            const data = await ApiFacade.getJson<UserResponse>(`${API_BASE_URL}/api/v1/users/me`, {
                accessToken: args.accessToken,
            });
            return data;
        } catch (error) {
            return thunkApi.rejectWithValue(error as SerializedError);
        }
    }
);
